// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__FTnuP","content":"styles_content__X3Xe-","row":"styles_row__Vn3lf"};